<template>
<div class="app-container1" >
   <div id="base" class="">

     <div id="u717" class="ax_default box_1">
        <div id="u717_div" class=""></div>
        <div id="u717_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u718" class="ax_default box_1">
        <div id="u718_div" class=""></div>
        <div id="u718_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u719" class="ax_default box_1">
        <div id="u719_div" class=""></div>
        <div id="u719_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u720" class="ax_default label">
        <div id="u720_div" class=""></div>
        <div id="u720_text" class="text ">
          <p><span>{{this.electricLevel1VO.yearuseusage}}Kwh</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u721" class="ax_default label">
        <div id="u721_div" class=""></div>
        <div id="u721_text" class="text ">
          <p><span>同比变化量</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u722" class="ax_default label">
        <div id="u722_div" class=""></div>
        <div id="u722_text" class="text ">
          <p><span>总用量</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u723" class="ax_default label">
        <div id="u723_div" class=""></div>
        <div id="u723_text" class="text ">
          <p><span>同比变化率</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u724" class="ax_default label">
        <div id="u724_div" class=""></div>
        <div id="u724_text" class="text ">
          <p><span>{{this.electricLevel1VO.yearchangeusage}}Kwh</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u725" class="ax_default label">
        <div id="u725_div" class=""></div>
        <div id="u725_text" class="text ">
          <p><span>{{this.electricLevel1VO.yearchangerate}}%</span></p>
        </div>
      </div>

      <!-- Unnamed (Image) -->
      <div id="u726" class="ax_default image"  v-if="this.electricLevel1VO.yearchangerate>=0">
        <img id="u726_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
        <div id="u726_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>
       <div id="u726" class="ax_default image"  v-if="this.electricLevel1VO.yearchangerate<0">
        <img id="u726_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
        <div id="u726_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>
      <!-- Unnamed (Image) -->
      <div id="u727" class="ax_default image"  v-if="this.electricLevel1VO.yearchangeusage>=0">
        <img id="u727_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
        <div id="u727_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>
      <div id="u727" class="ax_default image"  v-if="this.electricLevel1VO.yearchangeusage<0">
        <img id="u727_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
        <div id="u727_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>
      <!-- Unnamed (Group) -->
      <div id="u728" class="ax_default" data-left="292" data-top="212" data-width="351" data-height="68">

        <!-- Unnamed (Rectangle) -->
        <div id="u729" class="ax_default label">
          <div id="u729_div" class=""></div>
          <div id="u729_text" class="text ">
            <p><span>空调用电</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u730" class="ax_default label">
          <div id="u730_div" class=""></div>
          <div id="u730_text" class="text ">
            <p><span>{{this.electricLevel1VO.airconditionuseusage}}Kwh</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u731" class="ax_default label">
          <div id="u731_div" class=""></div>
          <div id="u731_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u732" class="ax_default label">
          <div id="u732_div" class=""></div>
          <div id="u732_text" class="text ">
            <p><span>总用量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u733" class="ax_default label">
          <div id="u733_div" class=""></div>
          <div id="u733_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u734" class="ax_default label">
          <div id="u734_div" class=""></div>
          <div id="u734_text" class="text ">
            <p><span>{{this.electricLevel1VO.airconditionchangeuseusage}}Kwh</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u735" class="ax_default label">
          <div id="u735_div" class=""></div>
          <div id="u735_text" class="text ">
            <p><span>{{this.electricLevel1VO.airconditionchangerate}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u736" class="ax_default image"  v-if="this.electricLevel1VO.airconditionchangeuseusage>=0">
          <img id="u736_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u736_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
       <div id="u736" class="ax_default image"  v-if="this.electricLevel1VO.airconditionchangeuseusage<0">
          <img id="u736_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u736_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
        <!-- Unnamed (Image) -->
        <div id="u737" class="ax_default image" v-if="this.electricLevel1VO.airconditionchangerate>=0">
          <img id="u737_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u737_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
          <div id="u737" class="ax_default image" v-if="this.electricLevel1VO.airconditionchangerate<0">
          <img id="u737_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u737_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u738" class="ax_default line">
        <img id="u738_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u354.svg"/>
        <div id="u738_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u739" class="ax_default label">
        <div id="u739_div" class=""></div>
        <div id="u739_text" class="text ">
          <p><span>分项年度用量</span></p>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u740" class="ax_default" data-left="292" data-top="311" data-width="347" data-height="70">

        <!-- Unnamed (Rectangle) -->
        <div id="u741" class="ax_default label">
          <div id="u741_div" class=""></div>
          <div id="u741_text" class="text ">
            <p><span>照明用电</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u742" class="ax_default label">
          <div id="u742_div" class=""></div>
          <div id="u742_text" class="text ">
            <p><span>{{this.electricLevel1VO.lightuseusage}}Kwh</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u743" class="ax_default label">
          <div id="u743_div" class=""></div>
          <div id="u743_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u744" class="ax_default label">
          <div id="u744_div" class=""></div>
          <div id="u744_text" class="text ">
            <p><span>总用量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u745" class="ax_default label">
          <div id="u745_div" class=""></div>
          <div id="u745_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u746" class="ax_default label">
          <div id="u746_div" class=""></div>
          <div id="u746_text" class="text ">
            <p><span>{{this.electricLevel1VO.lightchangeuseusage}}Kwh</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u747" class="ax_default label">
          <div id="u747_div" class=""></div>
          <div id="u747_text" class="text ">
            <p><span>{{this.electricLevel1VO.lightchangerate}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u748" class="ax_default image"  v-if="this.electricLevel1VO.lightchangeuseusage>=0">
          <img id="u748_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u748_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
        <div id="u748" class="ax_default image" v-if="this.electricLevel1VO.lightchangeuseusage<0">
          <img id="u748_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u748_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
        <!-- Unnamed (Image) -->
        <div id="u749" class="ax_default image"  v-if="this.electricLevel1VO.lightchangerate>=0">
          <img id="u749_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u749_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
         <div id="u749" class="ax_default image"  v-if="this.electricLevel1VO.lightchangerate<0">
          <img id="u749_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u749_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

      <!-- Unnamed (Group) -->
      <div id="u750" class="ax_default" data-left="289" data-top="411" data-width="350" data-height="68">

        <!-- Unnamed (Rectangle) -->
        <div id="u751" class="ax_default label">
          <div id="u751_div" class=""></div>
          <div id="u751_text" class="text ">
            <p><span>动力用电</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u752" class="ax_default label">
          <div id="u752_div" class=""></div>
          <div id="u752_text" class="text ">
            <p><span>{{this.electricLevel1VO.poweruseusage}}Kwh</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u753" class="ax_default label">
          <div id="u753_div" class=""></div>
          <div id="u753_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u754" class="ax_default label">
          <div id="u754_div" class=""></div>
          <div id="u754_text" class="text ">
            <p><span>总用量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u755" class="ax_default label">
          <div id="u755_div" class=""></div>
          <div id="u755_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u756" class="ax_default label">
          <div id="u756_div" class=""></div>
          <div id="u756_text" class="text ">
            <p><span>{{this.electricLevel1VO.powerchangeuseusage}}Kwh</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u757" class="ax_default label">
          <div id="u757_div" class=""></div>
          <div id="u757_text" class="text ">
            <p><span>{{this.electricLevel1VO.powerchangerate}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u758" class="ax_default image"  v-if="this.electricLevel1VO.powerchangeuseusage>=0">

          <img id="u758_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u758_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
        <div id="u758" class="ax_default image"  v-if="this.electricLevel1VO.powerchangeuseusage<0">

          <img id="u758_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u758_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u759" class="ax_default image"  v-if="this.electricLevel1VO.powerchangerate>=0">
          <img id="u759_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u759_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
<div id="u759" class="ax_default image"  v-if="this.electricLevel1VO.powerchangerate<0">
          <img id="u759_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u759_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>

        
      </div>

      <!-- Unnamed (Group) -->
      <div id="u760" class="ax_default" data-left="289" data-top="516" data-width="352" data-height="69">

        <!-- Unnamed (Rectangle) -->
        <div id="u761" class="ax_default label">
          <div id="u761_div" class=""></div>
          <div id="u761_text" class="text ">
            <p><span>特殊用电</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u762" class="ax_default label">
          <div id="u762_div" class=""></div>
          <div id="u762_text" class="text ">
            <p><span>{{this.electricLevel1VO.specialuseusage}}Kwh</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u763" class="ax_default label">
          <div id="u763_div" class=""></div>
          <div id="u763_text" class="text ">
            <p><span>同比变化量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u764" class="ax_default label">
          <div id="u764_div" class=""></div>
          <div id="u764_text" class="text ">
            <p><span>总用量</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u765" class="ax_default label">
          <div id="u765_div" class=""></div>
          <div id="u765_text" class="text ">
            <p><span>同比变化率</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u766" class="ax_default label">
          <div id="u766_div" class=""></div>
          <div id="u766_text" class="text ">
            <p><span>{{this.electricLevel1VO.specialchangeuseusage}}Kwh</span></p>
          </div>
        </div>

        <!-- Unnamed (Rectangle) -->
        <div id="u767" class="ax_default label">
          <div id="u767_div" class=""></div>
          <div id="u767_text" class="text ">
            <p><span>{{this.electricLevel1VO.specialchangerate}}%</span></p>
          </div>
        </div>

        <!-- Unnamed (Image) -->
        <div id="u768" class="ax_default image"  v-if="this.electricLevel1VO.specialchangeuseusage>=0">
          <img id="u768_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u768_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
        <div id="u768" class="ax_default image"  v-if="this.electricLevel1VO.specialchangeuseusage<0">
          <img id="u768_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u768_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
        
        <!-- Unnamed (Image) -->
        <div id="u769" class="ax_default image" v-if="this.electricLevel1VO.specialchangerate>=0">
          <img id="u769_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>
          <div id="u769_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
        <div id="u769" class="ax_default image" v-if="this.electricLevel1VO.specialchangerate<0">
          <img id="u769_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>
          <div id="u769_text" class="text " style="display:none; visibility: hidden">
            <p></p>
          </div>
        </div>
      </div>

    

      <!-- Unnamed (Rectangle) -->
      <div id="u771" class="ax_default label">
        <div id="u771_div" class=""></div>
        <div id="u771_text" class="text ">
          <p><span>用电详情</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u772" class="ax_default box_1">
        <div id="u772_div" class=""></div>
        <div id="u772_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u773" class="ax_default label">
        <div id="u773_div" class=""></div>
        <div id="u773_text" class="text ">
          <p><span>项目</span></p>
        </div>
      </div>

      <!-- Unnamed (Droplist) -->
      <div id="u774" class="ax_default droplist">
        <div id="u774_div" class=""></div>
        <!--
        <select id="u774_input" class="u774_input" v-model="queryParams.area">
          <option class="u774_input_option" selected value="">全部</option>
          <option class="u774_input_option" value="一期">一期</option>
          <option class="u774_input_option" value="二期">二期</option>
        </select>
        -->
          <el-select  @change="changeProject" clearable v-model="queryParams.projectId"  placeholder="选择项目">
                                            <el-option
                                                    v-for="item in projectList"
                                                    :label="item.projectName"
                                                    :value="item.projectId"
                                                    :key="item.projectId">
                                            </el-option>
                    </el-select>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u775" class="ax_default label">
        <div id="u775_div" class=""></div>
        <div id="u775_text" class="text ">
          <p><span></span></p>
        </div>
      </div>

      <!-- Unnamed (Image) -->
      <div id="u776" class="ax_default image">
        <!--
         <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              type="monthrange"
              range-separator=":"
              size="small"
              class="date-item"
              format="yyyy-MM"
              v-model="pickerOpts.pickerData"
                  :picker-options="pickerOpts"
                    @change="setDateRange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="起始时间"
              end-placeholder="截止时间"
            />
            -->
        <!--
        <img id="u776_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u392.png"/>
        -->
        <div id="u776_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u777" class="ax_default primary_button" @click="handleQuery">
        <div id="u777_div" class=""></div>
        <div id="u777_text" class="text ">
          <p><span>查询</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u778" class="ax_default box_1">
        <div id="u778_div" class=""></div>
        <div id="u778_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u779" class="ax_default heading_1">
        <div id="u779_div" class=""></div>
        <div id="u779_text" class="text ">
          <p><span></span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u780" class="ax_default heading_1">
        <div id="u780_div" class=""></div>
        <div id="u780_text" class="text ">
          <p><span style="font-family:'Arial-BoldMT', 'Arial Bold', 'Arial', sans-serif;font-weight:700;"></span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u781" class="ax_default box_1">
        <div id="u781_div" class=""></div>
        <div id="u781_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Line) -->
      <div id="u782" class="ax_default _水平线">
        <img id="u782_img" class="img " src="../../../../../../assets/common/consumption/icon/electric/u782.svg"/>
        <div id="u782_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u783" class="ax_default primary_button">
        <div id="u783_div" class=""></div>
        <div id="u783_text" class="text ">
          <p><span>导出</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u784" class="ax_default label">
        <div class="innerbox"  style="width: 100%; height:350px;position: absolute;z-index: 99;">
        <el-table  :data="consumptionList"  v-loading="loading"
                style="width: 100%;"
                
                >
         
                <el-table-column label="时间" align="center" prop="energyMonth" />
                <el-table-column label="分项" align="center" prop="childtype" />
                <el-table-column label="区域" align="center" prop="area" />
                <!--
              <el-table-column label="楼栋" align="center" prop="building" />
               <el-table-column label="单元" align="center" prop="unit" />
               -->
                <el-table-column label="用量" align="center" prop="useusage" />
               
             </el-table>
               <pagination v-show="total>0" 
                  :total="total" 
                  :page.sync="queryParams.pageNum"
                  :limit.sync="queryParams.pageSize"
                  @pagination="getList"/>
             </div>
      </div>

      <!-- Unnamed (Vertical Line) -->
      <div id="u785" class="ax_default line">
        <img id="u785_img" class="img " src="../../../../../../assets/common/consumption/icon/electric/u785.svg"/>
        <div id="u785_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u786" class="ax_default label">
        <div id="u786_div" class=""></div>
        <div id="u786_text" class="text ">
          <p><span>分项占比{{this.electricLevel1VO.airconditionusagepercent}}%</span></p>
        </div>
      </div>

      <!-- Unnamed (Vertical Line) -->
      <div id="u787" class="ax_default line">
        <img id="u787_img" class="img " src="../../../../../../assets/common/consumption/icon/electric/u785.svg"/>
        <div id="u787_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u788" class="ax_default label">
        <div id="u788_div" class=""></div>
        <div id="u788_text" class="text ">
          <p><span>分项占比{{this.electricLevel1VO.lightusagepercent}}%</span></p>
        </div>
      </div>

      <!-- Unnamed (Vertical Line) -->
      <div id="u789" class="ax_default line">
        <img id="u789_img" class="img " src="../../../../../../assets/common/consumption/icon/electric/u785.svg"/>
        <div id="u789_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u790" class="ax_default label">
        <div id="u790_div" class=""></div>
        <div id="u790_text" class="text ">
          <p><span>分项占比{{this.electricLevel1VO.powerusagepercent}}%</span></p>
        </div>
      </div>

      <!-- Unnamed (Vertical Line) -->
      <div id="u791" class="ax_default line">
        <img id="u791_img" class="img " src="../../../../../../assets/common/consumption/icon/electric/u785.svg"/>
        <div id="u791_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u792" class="ax_default label">
        <div id="u792_div" class=""></div>
        <div id="u792_text" class="text ">
          <p><span>分项占比{{this.electricLevel1VO.specialusagepercent}}%</span></p>
        </div>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u793" class="ax_default box_1">
      
        <div id="u793_div" class="" >
         <!--  列表显示分区信息，超出就滚动翻看 -->
         
           <div id="u7931" class="innerbox" >
             <!-- for循环展示区域详情信息 -->
           
<table style="border-collapse:collapse;border-spacing: 0;" cellspacing="0" cellpadding="0">

<template v-for="item in electricLevel1VO.arealist">
  <tr style="height:18px"> 
      <td  width="250px" ></td> 
      <td align="left" width="100"><span style="font-size:14px;">总用量</span></td>  
      <td align="left" width="80"><span style="font-size:14px;">{{item.useusage}}Kwh</span></td>        
  </tr>
   <tr style="height:18px">   
       <td  width="250px" >
      <span style="font-size:14px;"> {{item.area}}</span>
      </td> 
       <td align="left" width="100"><span style="font-size:14px;">同比变化量</span></td>  
       <td align="left" width="80" v-if="item.changeusage>=0"><span style="font-size:14px;">{{item.changeusage}}Kwh</span>
          <img id="u7261_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>  
        </td>  
         <td align="left" width="80" v-if="item.changeusage<0"><span style="font-size:14px;">{{item.changeusage}}Kwh</span>
          <img id="u7261_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>  
        </td>  
  </tr>
   <tr style="height:18px">    
      <td  width="250px" ></td> 
       <td align="left" width="100"><span style="font-size:14px;">同比变化率</span></td>  
       <td align="left" width="80" v-if="item.changerate>=0"><span style="font-size:14px;">{{item.changerate}}%</span>
        <img id="u7261_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u607.png"/>        
       </td>
       <td align="left" width="80" v-if="item.changerate<0"><span style="font-size:14px;">{{item.changerate}}%</span>
        <img id="u7261_img" class="img " src="../../../../../../assets/common/consumption/icon/year/u675.png"/>        
       </td>
  </tr>
  <tr style="height:18px">  
    <td colspan="3"></td>
  </tr>
</template>

 </table>


           </div>
        </div>
        <div id="u793_text" class="text " style="display:none; visibility: hidden">
        
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Group) 一期-->
    

      <!-- Unnamed (Rectangle) -->
      <div id="u804" class="ax_default label">
        <div id="u804_div" class=""></div>
        <div id="u804_text" class="text ">
          <p><span>区域年度用量</span></p>
        </div>
      </div>
     
      <!-- Unnamed (Line) -->
      <div id="u805" class="ax_default line">
        <img id="u805_img" class="img " src="../../../../../../assets/common/consumption/icon/month/u354.svg"/>
        <div id="u805_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>

      <!-- Unnamed (Group) 二期-->
 

      <!-- Unnamed (Rectangle) -->
      <div id="u816" class="ax_default label">
        <div id="u816_div" class=""></div>
        <div id="u816_text" class="text ">
          <p><span>分项</span></p>
        </div>
      </div>

      <!-- Unnamed (Droplist) -->
      <div id="u817" class="ax_default droplist">
        <div id="u817_div" class=""></div>
        <select id="u817_input" class="u817_input" v-model="queryParams.childtype">
          <option class="u817_input_option" selected value="">全部</option>
          <option class="u817_input_option" value="1">冷暖空调</option>
          <option class="u817_input_option" value="2">照明插座</option>
          <option class="u817_input_option" value="3">动力设备</option>
          <option class="u817_input_option" value="4">特殊用电</option>
        </select>
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u818" class="ax_default label">
        <div id="u818_div" class=""></div>
        <div id="u818_text" class="text ">
          <p><span>区域</span></p>
        </div>
      </div>

      <!-- Unnamed (Droplist) -->
      <div id="u819" class="ax_default droplist">
       <!--
        <div id="u819_div" class=""></div>
       
        <select id="u819_input" class="u819_input" v-model="queryParams.building">
          <option class="u819_input_option" selected value="">全部</option>
          <option class="u819_input_option" value="1栋">1栋</option>
          <option class="u819_input_option" value="2栋">2栋</option>
          <option class="u819_input_option" value="3栋">3栋</option>
          <option class="u819_input_option" value="4栋">4栋</option>
        </select>
        -->
         <tree-select
                                    v-model="queryParams.positionId"
                                    @select="selectPosition"
                                    :disable-branch-nodes="false"
                                    :multiple="false"
                                    :show-count="true"
                                    :flat="true"
                               
                                    :autoFocus="true"
                                    :placeholder="$t('commons.selectPlease')"
                                    :options="positionList" />
      </div>

      <!-- Unnamed (Rectangle) -->
      <div id="u820" class="ax_default label">
        <div id="u820_div" class=""></div>
        <div id="u820_text" class="text ">
          <p><span>周期</span></p>
        </div>
      </div>

      <!-- Unnamed (Droplist) -->
      <div id="u821" class="ax_default droplist">
      <el-date-picker
              :default-time="['00:00:00','23:59:59']"
              type="monthrange"
              range-separator=":"
              size="small"
              class="date-item"
              format="yyyy-MM"
              v-model="pickerOpts.pickerData"
                  :picker-options="pickerOpts"
                    @change="setDateRange"
              value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="起始时间"
              end-placeholder="截止时间"
            />
        <!--  <div id="u821_div" class=""></div>
       
        <select id="u821_input" class="u821_input" v-model="queryParams.unit">
          <option class="u821_input_option" selected value="">全部</option>
          <option class="u821_input_option" value="1单元">1单元</option>
          <option class="u821_input_option" value="2单元">2单元</option>
          <option class="u821_input_option" value="3单元">3单元</option>
          <option class="u821_input_option" value="4单元">4单元</option>
        </select>
        -->
      </div>

      <!-- Unnamed (Rectangle) -->
     
      <!-- Unnamed (Vertical Line)
      <div id="u826" class="ax_default line">
        <img id="u826_img" class="img " src="../../../../../../assets/common/consumption/icon/electric/u785.svg"/>
        <div id="u826_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>
 -->
      <!-- Unnamed (Rectangle) 占比-->
   

      <!-- Unnamed (Vertical Line) 
      <div id="u828" class="ax_default line">
       
        <img id="u828_img" class="img " src="../../../../../../assets/common/consumption/icon/electric/u785.svg"/>
        
        <div id="u828_text" class="text " style="display:none; visibility: hidden">
          <p></p>
        </div>
      </div>
-->
      <!-- Unnamed (Rectangle) 占比-->
  


 

 

  

      </div>
 </div>


</template>
<script>
import {
  getLevel1,//总汇总
  listLevel1,//总查询列表
  getPowerLevel2,//电
  listPower,//电
  getWaterLevel2,//水
  listWater,// 水
  getAirconditionLevel2,//空调
  listAircondition,//空调
  getPowerchildLevel2,//动力
  listPowerchild,//动力
  getLightchildLevel2,//照明
  listLightchild,//照明
  getSpecialchildLevel2,//特殊用电
  listSpecialchild,//特殊用电

} from "@/api/business/energy/consumption";
import "echarts/theme/macarons";
import Template from '../../../../../iori/modulx/template.vue';
 import{
        getProjectList
    }from '@/api/business/base/tenant/project';
    import {      
        getPositionTree
    } from '@/api/business/base/tenant/device';
     import {listToTree} from '@/utils/tree';
    import TreeSelect from '@riophae/vue-treeselect';   
        import '@riophae/vue-treeselect/dist/vue-treeselect.css';
import Pagination from '@/components/Pagination';
export default {
   name: "month",
    components: {Template,Pagination,TreeSelect},
    props: {
      //接收父组件传来的值
      flag: Number
    },
   
  data() {
    return {
        // flag:1,
        radio: 1,
         list: null,
       powerYear: "",
      waterYear: "",
      gasYear: "",
      hotYear: "",
      othersYear: "",
       list: null,
          // 遮罩层
      loading: false,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 岗位表格数据
      consumptionList: [],
        projectList:[],
               positionList:[],
      // 弹出层标题
      title: "",
      // 是否显示弹出层
      open: false,
      // 状态数据字典
      statusOptions: [],
      queryParams: {
                   pageNum: 1,
                   pageSize: 10,
                   childtype: '',
                   area: '',
                   areaselect: '',
                   building: '',
                   unit: '',
                   energytype: '',
                   areaid: null,
                 positionId : null,
                   projectId: null,
                   startTime: null,
                   endTime: null
               },
               // 日期范围查询组件
               pickerOpts: {
                   // 默认日期
                   pickerData: null,
                   // 快捷选项
                   shortcuts: null,
               },
      //接收后台传回来的查询列表数据
       queryList: {
           energyMonth: "",
           energyType: "",
           useusage: ""

       },

      monthAnalysis:[],
      yearlyAnalysis:[],
      seasonAnalysis:[],
      energyTypeList: [
        { itemCode: 1, itemName: "电量" },
        { itemCode: 2, itemName: "水量" },
        { itemCode: 3, itemName: "气量" },
        { itemCode: 4, itemName: "热量" },
        { itemCode: 5, itemName: "其他能源" },
      ],

       monthlyProportionOptions: null,
      monthlyProportionOptionsRate: null,
      monthlyProportionOptionsRate2: null,
      monthlyProportionOptionsForecast: null,
      seasonProportionOptions: null,
      seasonProportionOptionsRate: null,
      seasonProportionOptionsRate2: null,
       seasonProportionOptionsForecast: null,
      yearlyProportionOptions: null,
      yearlyProportionOptionsRate: null,
      yearlyProportionOptionsRate2: null,
      yearlyProportionOptionsForecast: null,
      fx1: '',
      fx11: '',
      fx2: '',
       fx21: '',
      fx3: '',
       fx31: '',
      fx4: '',
      fx41: '',
                //接收总统计数据的对象
        consumptionLevel1VO: {
              //----------汇总数据-------------
    //今年总量
    powerYear: "",//1
    waterYear: "",//2
    gasYear: "",//3
    hotYear: "",//4
    othersYear: "",//5


    //---今年用量变化
    powerChangeYear: "",
    waterChangeYear: "",
    gasChangeYear: "",
    hotChangeYear: "",
    othersChangeYear: "",

    //---今年用量变化率
    powerChangeRateYear: "",
    waterChangeRateYear: "",
    gasChangeRateYear: "",
    hotChangeRateYear: "",
    othersChangeRateYear: ""
        },
                //接收总统计数据的对象
      electricLevel1VO: {
            arealist: [],
            yearuseusage: "",
            yearchangeusage: "",
            yearchangerate: "",

            timeno: "",
            airconditionuseusage: "",
            airconditionchangeuseusage: "",
            airconditionchangerate: "",
            airconditionusagepercent: "",

            lightuseusage: "",
            lightchangeuseusage: "",
            lightchangerate: "",
            lightusagepercent: "",

            poweruseusage: "",
            powerchangeuseusage: "",
            powerchangerate: "",
            powerusagepercent: "",

            specialuseusage: "",
            specialchangeuseusage: "",
            specialchangerate: "",
            specialusagepercent: "",
              //中水
            reclaimedwateruseusage: "",
            reclaimedwaterchangeuseusage: "",
            reclaimedwaterchangerate: "",
            reclaimedwaterusagepercent: "",
              //自来水
            tapwateruseusage: "",
            tapwaterchangeuseusage: "",
            tapwaterchangerate: "",
            tapwaterusagepercent: "",
        }
    }
  },
   created() {
      getLevel1(this.queryParams).then((response) => {
           //alert("11111");
          this.consumptionLevel1VO = response.data;
   
           this.electricLevel1VO.yearuseusage=this.consumptionLevel1VO.powerYear;
           this.electricLevel1VO.yearchangeusage=this.consumptionLevel1VO.powerChangeYear;
             this.electricLevel1VO.yearchangerate=this.consumptionLevel1VO.powerChangeRateYear;
            this.fx1=this.consumptionLevel1VO.powerYear;
        });
      getPowerLevel2(this.queryParams).then((response) => {
           //alert("11111");
          this.electricLevel1VO = response.data;
          // alert( this.electricLevel1VO.arealist[0].area);
          //  alert( this.electricLevel1VO.arealist[0].changeusage);
          //   alert( this.electricLevel1VO.arealist[0].useusage);
          //    alert( this.electricLevel1VO.arealist[0].changerate);

          //if(this.electricLevel1VO.airconditionuseusage==null)
       //   this.electricLevel1VO.yearuseusage=Number(this.electricLevel1VO.airconditionuseusage)+Number(this.electricLevel1VO.lightuseusage)+Number(this.electricLevel1VO.specialuseusage)+Number(this.electricLevel1VO.poweruseusage);
           
       });
    
    this.getProjectList();

          // alert(this.electricLevel1VO.yearuseusage);
        //this.fx11=this.electricLevel1VO.poweruseusage/this.fx1;
        
   },
  methods: {
      // 设置日期范围查询条件
     setFlag1(iflag) {
        // alert("child="+iflag);
        //   this.flag=iflag;
        this.$emit("changeFlag",iflag);
       //  alert("child="+iflag);

     },
          setDateRange(dateRange) {
        
          //alert(dateRange[0].substr(0,7));
        
         if (dateRange) {
                    this.queryParams.startTime = dateRange[0].substr(0,7);
                    this.queryParams.endTime = dateRange[1].substr(0,7);
                    
          } else {// 清空
                    this.queryParams.startTime = null;
                    this.queryParams.endTime = null;
           }
               
         },
     getChange(typeid){
        if(typeid==1){
        
          //电月度数据 
  
          this.monthlyProportionOptionsRate = this.monthlyProportionRate(1);
          this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(1);
          
        }else if(typeid==2){
          //水月度数据 
          this.monthlyProportionOptionsRate = this.monthlyProportionRate(2);
           this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(2);
        }else if(typeid==3){
         //气月度数据 
         this.monthlyProportionOptionsRate = this.monthlyProportionRate(3);
          this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(3);
        }else if(typeid==4){
          //热月度数据 
          this.monthlyProportionOptionsRate = this.monthlyProportionRate(4);
           this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(4);
        }else if(typeid==5){
         // 其他月度数据 
         this.monthlyProportionOptionsRate = this.monthlyProportionRate(5);
          this.monthlyProportionOptionsForecast=this.monthlyProportionForecast(5);
        }
      },
//--------------------
   /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
       /** 查询列表 */
    getList() {
      this.loading = true;
      //alert(this.queryParams.positionId);
      this.queryParams.areaid=this.queryParams.positionId;
      listPower(this.queryParams).then((response) => {
           //alert("11111");
           for(var i=0;i<response.rows.length;i++){
             //alert(response.rows[i].childtype);
               if(response.rows[i].childtype==1){
                 response.rows[i].energyMonth=response.rows[i].energyyear+'-'+response.rows[i].energyMonth;
                 response.rows[i].childtype='冷暖空调';
              }
                 if(response.rows[i].childtype==2){
                 response.rows[i].energyMonth=response.rows[i].energyyear+'-'+response.rows[i].energyMonth;
                 response.rows[i].childtype='照明插座';
              }
                 if(response.rows[i].childtype==3){
                 response.rows[i].energyMonth=response.rows[i].energyyear+'-'+response.rows[i].energyMonth;
                 response.rows[i].childtype='动力设备';
              }
                 if(response.rows[i].childtype==4){
                 response.rows[i].energyMonth=response.rows[i].energyyear+'-'+response.rows[i].energyMonth;
                 response.rows[i].childtype='特殊用电';
              }
           }
          this.consumptionList = response.rows;
          this.total = response.total;
        this.loading = false;
        });
    
     },
    //----------------位置选择----------------------------
             selectPosition(node){
                this.queryParams.positionId = node.positionId;
                //alert(this.listQuery.positionId);
               },
                
           
            getProjectList(companyId){
                getProjectList({"companyId":companyId}).then(res=>{
                    this.projectList = res;
                })
               // alert(this.fx1);
                
            },
           changeProject() {
                if(this.queryParams.projectId == ''){
                    this.queryParams.projectId = null;
                    this.queryParams.positionId = null;
                    this.positionList = [];
                }else{                   
                   getPositionTree({"projectId":this.queryParams.projectId}).then(response =>{
                     
                        //alert(this.listQuery.projectId);
                        this.queryParams.positionId = null;
                        this.positionList = [];
                        let data = listToTree(response,"positionId","parentId");
                        this.recursivePosition(data)
                    });
                }
            },
            //递归位置列表修改属性及数据结构
            recursivePosition(row){
                let data = row.map(v => {
                    v.label = v.positionName;
                    v.id = v.positionId;
                    if(v.children != undefined){
                        this.recursivePosition(v.children);
                    }
                    return v
                })
                this.positionList = data;
            },
          
           

    //----------------------------------------------
//--------------------
}
}
</script>
<style scoped src="../../../../../../assets/common/consumption/css/electric/styles.css"></style>
<style scoped src="../../../../../../assets/common/consumption/css/styles.css"></style>
<style scoped src="../../../../../../assets/common/rp_page.css"></style>
<style scoped>
  .app-container1 {
  margin: 0px;
  
  background-color: rgba(243, 247, 255, 1);
  border-radius: 5px;
  min-height: calc(100vh + 500px);
  
}
.pagination-container {
  background: rgba(255, 255, 255, 0.0235294117647059);
  padding: 18px 0px;
  float: left;
  z-index: 99;
position: absolute;
}
 .innerbox{
            overflow-x: hidden;
            overflow-y: auto;       
        }
        /*滚动条样式*/
   .innerbox::-webkit-scrollbar {
           	width: 8px;
            height: 8px;
            background-color: #F5F5F5;
    }
    .innerbox::-webkit-scrollbar-thumb {
            	border-radius:3px;
	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,.3);
	background-color: #555;
    }
    .innerbox::-webkit-scrollbar-track {
          	-webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
            border-radius: 3px;
            background-color: #F5F5F5;

    }
  .fontset{
      font-family:'PingFangSC-Regular', 'PingFang SC', sans-serif;
      font-weight:400;
      font-style:normal;
  }
</style>
